import {ItemsListOptions} from './itemsListOptions';

export class ItemWrapper {
    private _metadata: Array<string>;
    private _searchMetadata: Array<string>;

    constructor(private _item: Object, private _options: ItemsListOptions, private _index: number) {
        this._metadata = [];
        for (let i = 0; i < this._options.metaDataProperties.length; i++) {
            this._metadata.push(this._item[this._options.metaDataProperties[i]]);

        }

        this._searchMetadata = [];
        for (let i = 0; i < this._options.searchMetaDataProperties.length; i++) {
            this._searchMetadata.push(this._item[this._options.searchMetaDataProperties[i]]);
        }
    }

    get item(): any {
        return this._item;
    }

    get id(): number {
        return this._options.itemIdProperty
            ? this._item[this._options.itemIdProperty]
            : this._index;
    }

    get icon(): string {
        return this._item[this._options.itemIconProperty];
    }

    get tooltip(): string {
        return this._item[this._options.itemIconTooltipProperty];
    }

    get header(): string {
        return this._item[this._options.itemHeaderProperty];
    }

    get rightHeader(): string {
        return this._item[this._options.itemRightHeaderProperty];
    }

    get rightHeaderUom(): string {
        return this._item[this._options.itemRightHeaderUomProperty];
    }

    get metadata(): Array<string> {
        return this._metadata;
    }

    get searchMetadata(): Array<string> {
        return this._searchMetadata;
    }

    isMatch(term: string, groupValue?: string): boolean {

        const matchesGroup = groupValue == null || this._options.groupingProperty === groupValue;

        if (this.searchMetadata.length > 0)
            return this.isInSearchMetadata(term, groupValue) && matchesGroup;

        return matchesGroup
            && (this.contains(this.header, term)
            || this.contains(this.tooltip, term)
            || this.contains(this.rightHeader, term)
            || this.isInMetadata(term)
            );
    }

    private isInMetadata(term: string): boolean {
        let isInMetadata = false;
        for (let i = 0; i < this.metadata.length; i++) {
            if (this.contains(this.metadata[i], term)) {
                isInMetadata = true;
                break;
            }
        }
        return isInMetadata;
    }

    private isInSearchMetadata(term: string, groupValue?: string): boolean {
        let isInSearchMetadata = false;
        for (let i = 0; i < this.searchMetadata.length; i++) {
            if (this.contains(this.searchMetadata[i], term)) {
                isInSearchMetadata = true;
                break;
            }
        }
        return isInSearchMetadata;
    }

    private contains(value: string, term: string): boolean {
        return value
            && value.toString().toLowerCase().indexOf(term.toLowerCase()) > -1;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/itemsList/models/itemWrapper.ts
 **/